// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3xyY2","inputDescription":"styles_inputDescription__3hBCr"};